import React from 'react';
import PropTypes from 'prop-types';

export default class AdFox extends React.Component {
  constructor (props) {
    super(props);

    this.div = null;
  }

  componentDidMount () {
    const hasContainer = document.getElementById(this.props.id);

    if (window.Ya && window.Ya.adfoxCode && hasContainer) {
      try {
        window.Ya.adfoxCode.create({
          ownerId: 252085,
          containerId: this.props.id,
          params: {
            pp: 'h',
            ps: this.props.regionId,
            p2: this.props.placeId
          },

          onRender: this.props.onRender,
          onStub: this.props.onStub,
          onError: this.props.onError
        });
      } catch (e) {}
    }
  }

  componentWillUnmount () {
    if (window.Ya && window.Ya.adfoxCode) {
      try {
        window.Ya.adfoxCode.destroy(this.props.id);
      } catch (e) {}
    }
  }

  render () {
    if (!this.div) {
      this.div = <div id={this.props.id} className={['no-print', this.props.className].join(' ')} />;
    }

    return this.div;
  }
}

AdFox.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  regionId: PropTypes.string.isRequired,
  placeId: PropTypes.string.isRequired,
  className: PropTypes.string,
  onRender: PropTypes.func,
  onStub: PropTypes.func,
  onError: PropTypes.func
};

AdFox.defaultProps = {
  onRender: () => {},
  onStub: () => {},
  onError: () => {},
  className: ''
};



// WEBPACK FOOTER //
// ./src/ui/AdFox/AdFox.jsx